import { render, staticRenderFns } from "./SimilarListChart.vue?vue&type=template&id=83abcaf4&scoped=true&"
import script from "./SimilarListChart.vue?vue&type=script&lang=ts&"
export * from "./SimilarListChart.vue?vue&type=script&lang=ts&"
import style0 from "./SimilarListChart.vue?vue&type=style&index=0&id=83abcaf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83abcaf4",
  null
  
)

export default component.exports